// extracted by mini-css-extract-plugin
export default {"eye_chart_font":"visualAcuity_eye_chart_font__Ngd24","snellen_chart_font":"visualAcuity_snellen_chart_font__IQQ4F","sloan_chart_font":"visualAcuity_sloan_chart_font__5qs2B"};